
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import { Truck } from "@/models/api/trucks/getTrucks";
import TruckModule from "@/store/modules/truck";
import ModalMixin from "./mixin";
import TruckMap from "@/components/truck/TruckMap.vue";

const truckModuleState = getModule(TruckModule);

@Component({
  name: modals.truckMapViewModal,
  components: {
    TruckMap,
  }
})
export default class TruckMapViewModal extends ModalMixin {
  $refs!: {
    truckMap: TruckMap;
  };
  mapkey: number = 0;
  truck: Truck = null;
  loadingComplete: boolean = false;

  async load() {
    this.show();
    if(!truckModuleState.currentTruck || (this.selectedItem.id != truckModuleState.currentTruck.id)){
      this.truck = await truckModuleState.getTruck(this.selectedItem.id)
    }
    else{
      this.truck = truckModuleState.currentTruck;
    }
    this.loadingComplete = true;
    truckModuleState.setCurrentTruck(this.truck);
  }

  showMap() {
    return this.mapkey > 0 && this.loadingComplete;
  }

  refreshMap() {
    this.mapkey += 1
  }
  reset() {
    this.truck = null;
    this.mapkey = 0;
    this.loadingComplete = false;
  }
}
